import { styled } from '@material-ui/core';

import Button from '@/components/Button';

export const StyledButton = styled(Button)({
  backgroundColor: '#111',
  color: '#FFF',
  textAlign: 'center',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '135%',
  '&:hover': {
    backgroundColor: '#333',
  },
});
